import { useState, useEffect, useRef } from "react";
import "./deleteaccount.css";
import Footer from "./Footer.jsx";
import sprout from "./assets/sprout.png";
import deleteImage from "./assets/deleteimage.png";
import deleteImageMain from "./assets/deleteimagemain.png";

export default function DeleteAccount() {
  const [timer, setTimer] = useState(60);
  const [showResend, setShowResend] = useState(false);
  const [otp, setOtp] = useState(Array(6).fill("")); 
  const [showConfirmPopup, setShowConfirmPopup] = useState(false); 
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otpSentMessage, setOtpSentMessage] = useState("");
  const otpRefs = useRef([]);
  otpRefs.current = [];

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (!value) return;
  
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
  
    if (value && index < otpRefs.current.length - 1) {
      otpRefs.current[index + 1].focus();
    }
  
    if (newOtp.every(d => d !== "") && index === 5) {
      setShowConfirmPopup(true);
    }
  };
  

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      otpRefs.current[index - 1].focus();
    }
  };

  useEffect(() => {
    let interval = null;
    if (isOtpSent && timer > 0) {
      interval = setInterval(() => {
        setTimer(prev => prev - 1);
      }, 1000);
    } else if (timer === 0 && isOtpSent) {
      setShowResend(true);
    }
    return () => clearInterval(interval);
  }, [isOtpSent, timer]);
  

  const handleResend = () => {
    setTimer(60);
    setShowResend(false);
    setIsOtpSent(true);
  };

  const handleSend = () => {
    setIsOtpSent(true);
    setTimer(60);
    setShowResend(false);
    setOtpSentMessage("OTP sent successfully ✅");
    setTimeout(() => setOtpSentMessage(""), 3000)
  };
  

  const handlePopupResponse = (answer) => {
    if (answer === "yes") {
      alert("Your account will be deleted."); 
    } else {
      window.location.href = "/"; 
    }
    setShowConfirmPopup(false);
  };
  

  return (
    <div className="delete-account-closure-page">
        <div className="delete-header">
        <div className="delete-navbar-left">
        <img src={sprout} className="delete-logo" alt="Ecoindex logo" />
          <h1 className="delete-header-title">Support Center</h1>
          </div>
        </div>
        {otpSentMessage && (
  <div className="delete-custom-alert">
    <span className="delete-custom-alert-icon"></span>
    {otpSentMessage}
  </div>
)}
      {/* Main Content */}
      <main className="delete-main-content">
      <div className="delete-main-flex">
    <div className="delete-image-container">
      <img src={deleteImageMain} alt="Delete illustration" className="delete-main-image" />
    </div>
    <div className="delete-form-content">
        <h2 className="delete-section-title">We are sad to see you go !</h2>
        <div className="delete-email-field">
          <label htmlFor="email" className="delete-email-label">Please provide your registered Email Id</label>
          <input
            type="email"
            id="email"
            className="delete-email-input"
            placeholder="Enter your email ID"
          />
        </div>
        <p className="delete-section-description">
          We're sorry to see you go! Please let us know a little about why you're closing your account
        </p>

        <textarea
          className="delete-feedback-textarea"
          placeholder="Your feedback..."
        />
         <div className="delete-button-group">
          <button className="delete-send-button" onClick={handleSend}>Send</button>
          <button className="delete-cancel-button">Cancel</button>
        </div>
          <div className="delete-otp-section">
          <label htmlFor="otp" className="delete-otp-label">Enter the OTP</label>
          <div className="delete-otp-input-container">
            {[...Array(6)].map((_, i) => (
              <input
              key={i}
              type="text"
              maxLength="1"
              inputMode="numeric"
              pattern="[0-9]*"
              className="delete-otp-input"
              ref={(el) => otpRefs.current[i] = el}
                onChange={(e) => handleOtpChange(e, i)}
                onKeyDown={(e) => handleOtpKeyDown(e, i)}
            />
            ))}
          </div>
          <p className="delete-otp-info">
            OTP is sent to the above email ID{" "}
            {!showResend ? (
              <span className="delete-timer">{timer}s</span>
            ) : (
              <span className="delete-resend" onClick={handleResend}>
                Resend It
              </span>
            )}
          </p>
        </div>
        </div>
        </div>
      </main>
      {showConfirmPopup && (
  <div className="delete-popup-overlay">
    <div className="delete-popup-modal">
      <p>Are you sure you want to delete your account?</p>
      <img src={deleteImage} alt="Delete confirmation" className="delete-popup-image" />
      <div className="delete-popup-buttons">
        <button onClick={() => handlePopupResponse("yes")}>Yes</button>
        <button onClick={() => handlePopupResponse("no")}>No</button>
      </div>
    </div>
  </div>
  
)}
       <Footer />
    </div>
  );
}
